import { assign } from 'lodash';
import * as api from 'api/api-instance';
import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  saved: null,
  saveError: null,
  error: null,
  notFound: null,
  meta: {},
  data: {},
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  saved: null,
  saveError: null,
  error: null,
  notFound: null,
};

const state = assign({}, initState);

const getters = {
  InstanceSubscriptionOptions: state => state,
};

const actions = {
  GetInstanceSubscriptionOptions({ commit }, parameters) {
    const query = parameters.query;

    commit(types.INSTANCE_SUBSCRIPTION_OPTIONS_START);
    api.subscriptionOptions(
      query,
      (response) => {
        commit(types.INSTANCE_SUBSCRIPTION_OPTIONS_SUCCESSFUL, { response });
      },
      (description, status, error) => {
        commit(types.INSTANCE_SUBSCRIPTION_OPTIONS_ERROR, { error });
      },
    );
  },
  SaveInstanceSubscriptionSelection({ commit }, parameters) {
    return new Promise((resolve, reject) => {
      const payload = parameters.payload;

      commit(types.SAVE_INSTANCE_SUBSCRIPTION_SELECTION_START);
      api.subscriptionSelection(
        payload,
        (response) => {
          commit(types.SAVE_INSTANCE_SUBSCRIPTION_SELECTION_SUCCESSFUL, { response });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.SAVE_INSTANCE_SUBSCRIPTION_SELECTION_ERROR, { saveError });
          reject(saveError);
        },
      );
    });
  },
  ClearInstanceSubscriptionOptions({ commit }) {
    commit(types.CLEAR_INSTANCE_SUBSCRIPTION_OPTIONS_STORE);
  },
};

const mutations = {
  [types.INSTANCE_SUBSCRIPTION_OPTIONS_START](state) {
    assign(state, neutralState, { fetching: true });
  },
  [types.INSTANCE_SUBSCRIPTION_OPTIONS_ERROR](state, { error }) {
    console.log('INSTANCE_SUBSCRIPTION_OPTIONS_ERROR', error);
    assign(state, neutralState, { error });
  },
  [types.INSTANCE_SUBSCRIPTION_OPTIONS_SUCCESSFUL](state, { response }) {
    console.log('InstanceSubscriptionOptions', response);
    assign(state, neutralState, { data: response.data, meta: response.meta });
  },
  [types.SAVE_INSTANCE_SUBSCRIPTION_SELECTION_START](state) {
    assign(state, neutralState, { saving: true });
  },
  [types.SAVE_INSTANCE_SUBSCRIPTION_SELECTION_ERROR](state, { saveError }) {
    assign(state, neutralState, { saveError });
  },
  [types.SAVE_INSTANCE_SUBSCRIPTION_SELECTION_SUCCESSFUL](state, { response }) {
    assign(state, neutralState, { saved: true, data: response.data, meta: response.meta });
  },
  [types.CLEAR_INSTANCE_SUBSCRIPTION_OPTIONS_STORE](state) {
    assign(state, initState);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/instance/entities/instance-subscription-options.js